"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createTableUIStatefulColumns = void 0;
var react_1 = __importStar(require("react"));
var antd_1 = require("antd");
var TreeFilterAndOrder_1 = require("../TreeFilterAndOrder");
var consts_1 = require("./consts");
var createTableUIStatefulColumns = function (props) {
    var columnsRenderMapFnMaybe = props.columnsRenderMap, actionsRender = props.actionsRender, tableColumnsTreeFilterAndOrderProps = props.tableColumnsTreeFilterAndOrderProps;
    var treeFilterKey = tableColumnsTreeFilterAndOrderProps.key, _a = tableColumnsTreeFilterAndOrderProps.usePersistent, usePersistent = _a === void 0 ? true : _a;
    var useColumnsToggleHook = usePersistent
        ? TreeFilterAndOrder_1.useTreeFilterAndOrder
        : TreeFilterAndOrder_1.useTreeFilterAndOrderSimple;
    var useTableUI = function (_a) {
        var on = _a.on, extended = _a.extended, tableColumnsTreeFilterAndOrderPropsExtended = _a.tableColumnsTreeFilterAndOrderProps, sorting = _a.sorting, selectionColumnPosition = _a.selectionColumnPosition, expansionColumnPosition = _a.expansionColumnPosition, _b = _a.hideColumns, hideColumns = _b === void 0 ? [] : _b, pagination = _a.pagination, actionColumnProps = _a.actionColumnProps, fillWidth = _a.fillWidth, rest = __rest(_a, ["on", "extended", "tableColumnsTreeFilterAndOrderProps", "sorting", "selectionColumnPosition", "expansionColumnPosition", "hideColumns", "pagination", "actionColumnProps", "fillWidth"]);
        var columnsRenderMap = react_1.useMemo(function () { return columnsRenderMapFnMaybe(extended || {}); }, [extended]);
        /* tree-filter */
        var filterAndOrderCols = react_1.useMemo(function () {
            return Object.keys(columnsRenderMap).reduce(function (acc, key) {
                var _a;
                var val = columnsRenderMap[key];
                if (hideColumns === null || hideColumns === void 0 ? void 0 : hideColumns.includes(key))
                    return acc;
                return __assign(__assign({}, acc), (_a = {}, _a[key] = {
                    title: val.title,
                    key: key,
                }, _a));
            }, {});
        }, [columnsRenderMap, hideColumns]);
        var treeFilterKeyExtended = (tableColumnsTreeFilterAndOrderPropsExtended !== null && tableColumnsTreeFilterAndOrderPropsExtended !== void 0 ? tableColumnsTreeFilterAndOrderPropsExtended : {}).key;
        if (!treeFilterKey && !treeFilterKeyExtended && usePersistent)
            throw Error("No TreeFilter Key Provided with usePersistent true. \n        Either provide a key or set usePersistent to false.\n      ");
        var _c = useColumnsToggleHook(__assign(__assign(__assign({ columns: filterAndOrderCols }, tableColumnsTreeFilterAndOrderProps), tableColumnsTreeFilterAndOrderPropsExtended), { 
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            key: treeFilterKeyExtended !== null && treeFilterKeyExtended !== void 0 ? treeFilterKeyExtended : treeFilterKey, hideColumns: hideColumns })), filterAndOrderColumns = _c.state, toggler = _c.jsx.toggler;
        /* sorting */
        var getSort = react_1.useCallback(function () {
            return function (field) {
                return (sorting === null || sorting === void 0 ? void 0 : sorting.fields.includes(field))
                    ? {
                        sorter: !!sorting,
                        sortOrder: ((sorting === null || sorting === void 0 ? void 0 : sorting.sortField) === field && sorting.sortOrder) ||
                            undefined,
                    }
                    : {};
            };
        }, [sorting]);
        /* making columns */
        var columns = react_1.useCallback(function () {
            var cols = __spreadArray([], filterAndOrderColumns.map(function (key) { return (__assign(__assign(__assign({}, getSort()(key)), columnsRenderMap[key]), { dataIndex: key })); })).filter(function (_a) {
                var dataIndex = _a.dataIndex;
                return !hideColumns.includes(dataIndex);
            });
            if (selectionColumnPosition !== undefined) {
                cols.splice(selectionColumnPosition, 0, antd_1.Table.SELECTION_COLUMN);
            }
            if (expansionColumnPosition !== undefined) {
                cols.splice(expansionColumnPosition, 0, antd_1.Table.EXPAND_COLUMN);
            }
            // pushing a column to just take the width for other columns
            if (fillWidth) {
                // for fluid width.
                cols.push({});
            }
            if (actionsRender && !hideColumns.includes("__actions")) {
                cols.push(__assign(__assign({ title: "", width: consts_1.DEFAULT_TABLE_ACTION_COLUMN_WIDTH }, actionColumnProps), { render: actionsRender === null || actionsRender === void 0 ? void 0 : actionsRender({ on: on }), fixed: "right" }));
            }
            return cols;
        }, [
            filterAndOrderColumns,
            selectionColumnPosition,
            expansionColumnPosition,
            getSort,
            columnsRenderMap,
            hideColumns,
            on,
            actionColumnProps,
            fillWidth,
        ])();
        return {
            table: (react_1.default.createElement(antd_1.Table, __assign({ size: "small" }, rest, { columns: columns, pagination: pagination === false
                    ? false
                    : __assign(__assign({}, pagination), { showQuickJumper: true }) }))),
            toggler: toggler,
        };
    };
    return {
        useTableUI: useTableUI,
    };
};
exports.createTableUIStatefulColumns = createTableUIStatefulColumns;
